(() => {
  function initGallery(section) {

      var sliderComponent = section.querySelector('slider-component');
      var slider = sliderComponent ? sliderComponent.querySelector('.product__media-list') : null;
      var thumbItems = section.querySelectorAll('.product__media-thumbnail-item');
      if (!slider || !thumbItems.length || slider.dataset.emThumbReady) return;
      slider.dataset.emThumbReady = 'true';

      var currentActiveId = '';

      function getVisibleSlides() {
        return Array.prototype.filter.call(
          slider.querySelectorAll('li'),
          function(item) {
            return item.clientWidth > 0;
          }
        );
      }

      function setActive(mediaId) {
        if (!mediaId || mediaId === currentActiveId) return;
        currentActiveId = mediaId;

        Array.prototype.forEach.call(thumbItems, function(item) {
          var isActive = item.getAttribute('data-target') === mediaId;
          item.classList.toggle('is-active', isActive);
          var button = item.querySelector('button');
          if (button) button.setAttribute('aria-current', String(isActive));
        });

        var activeThumb = section.querySelector('.product__media-thumbnail-item.is-active');
        if (activeThumb && activeThumb.scrollIntoView) {
          var strip = activeThumb.parentElement;
          var left = activeThumb.offsetLeft - strip.offsetLeft;
          if (left < strip.scrollLeft) strip.scrollTo({ left: left, behavior: 'smooth' });
          else if (left + activeThumb.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollTo({ left: left + activeThumb.offsetWidth - strip.clientWidth, behavior: 'smooth' });
        }
      }

      function updateActiveFromScroll() {
        var visibleSlides = getVisibleSlides();
        if (!visibleSlides.length) return;

        var scrollLeft = slider.scrollLeft;
        var activeSlide = null;

        visibleSlides.forEach(function(slide) {
          if (!activeSlide) {
            activeSlide = slide;
            return;
          }
          if (Math.abs(slide.offsetLeft - scrollLeft) < Math.abs(activeSlide.offsetLeft - scrollLeft)) {
            activeSlide = slide;
          }
        });

        if (activeSlide) {
          setActive(activeSlide.getAttribute('data-media-id'));
        }
      }

      Array.prototype.forEach.call(thumbItems, function(item) {
        var button = item.querySelector('button');
        if (!button) return;
        button.addEventListener('click', function() {
          var targetId = item.getAttribute('data-target');
          var targetSlide = slider.querySelector('[data-media-id="' + targetId + '"]');
          if (!targetSlide) return;
          slider.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
          setActive(targetId);
        });
      });

      var rafId = null;
      slider.addEventListener('scroll', function() {
        if (rafId) return;
        rafId = window.requestAnimationFrame(function() {
          rafId = null;
          updateActiveFromScroll();
        });
      });

      var form = section.querySelector('form[action*="/cart/add"]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      if (idInput) {
        idInput.addEventListener('change', function() {
          window.setTimeout(updateActiveFromScroll, 0);
        });
      }

      updateActiveFromScroll();
    }

  function init(section) {
    if (section.dataset.emReady) return;
    section.dataset.emReady = 'true';
    initGallery(section);
    const reviewTarget = document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-carousel-wrapper');
    if (reviewTarget) {
      if (!reviewTarget.id) reviewTarget.id = 'em-customer-reviews';
      section.querySelectorAll('[data-em-review-link]').forEach(link => {
        if (link.hash === '#judgeme_product_reviews' || link.hash.startsWith('#em-reviews-')) link.href = `#${reviewTarget.id}`;
      });
    }
    section.querySelectorAll('[data-em-review]').forEach(review => {
      const items = Array.from(review.querySelectorAll('[data-em-review-item]'));
      const index = review.dataset.emReviewMode === 'random' && !window.Shopify?.designMode ? Math.floor(Math.random() * items.length) : 0;
      items.forEach((item, i) => { item.hidden = i !== index; });
    });
    const picker = section.querySelector('variant-radios,variant-selects');
    const form = section.querySelector('product-form form');
    if (!picker || !form) return;
    const variants = JSON.parse(picker.querySelector('[type="application/json"]').textContent);
    const translations = JSON.parse(section.querySelector('[data-em-translations]').textContent);
    const input = form.querySelector('[name="id"]');
    const quantity = section.querySelector('.product-form__quantity');
    const buttons = form.querySelector('.product-form__buttons');
    const placeholder = document.createElement('span');
    placeholder.hidden = true;
    if (quantity) quantity.before(placeholder);
    const mobile = window.matchMedia('(max-width: 749px)');
    const price = section.querySelector('.em-product-price');
    const summaryPrice = section.querySelector('[data-em-price]');
    const gallery = section.querySelector('.product__media-list');
    let currentId;
    function positionQuantity() {
      if (!quantity) return;
      if (mobile.matches || section.classList.contains('em-desktop-redesign')) buttons.prepend(quantity);
      else placeholder.after(quantity);
    }
    function syncPrice() {
      const value = price?.querySelector('.price--on-sale .price__sale .price-item--sale') || price?.querySelector('.price__regular .price-item--regular');
      if (value && summaryPrice) summaryPrice.textContent = value.textContent.trim();
    }
    function update() {
      const variant = variants.find(v => String(v.id) === input.value);
      if (!variant) return;
      section.querySelector('[data-em-selection]').textContent = variant.options.join(' · ');
      const frameIndex = translations.optionNames.findIndex(name => /frame/i.test(name));
      const frame = variant.options[frameIndex] || '';
      const delivery = section.querySelector('[data-em-delivery-country="CA"] [data-em-delivery-copy]');
      if (delivery) delivery.textContent = /^(no frame|unframed)$/i.test(frame) ? delivery.dataset.emUnframed : delivery.dataset.emFramed;
      const note = section.querySelector('[data-em-frame-note]');
      if (note) note.textContent = /^(no frame|unframed)$/i.test(frame) ? translations.printOnly : frame ? `${frame} · ${translations.framed}` : '';
      picker.querySelectorAll('.em-option').forEach(e => {
        const selected = e.querySelector('input:checked');
        const text = e.querySelector('.em-option-selected');
        if (text && selected) text.textContent = ` · ${selected.value}`;
      });
      if (currentId !== input.value && mobile.matches && gallery) {
        const colorIndex = translations.optionNames.findIndex(name => /colou?r/i.test(name));
        const color = String(variant.options[colorIndex] || '').toLowerCase();
        const desiredFrame = /black/i.test(frame) ? 'black' : 'walnut';
        const slides = Array.from(gallery.children);
        const target = slides.find(e => {
          const image = e.querySelector('img');
          const src = String(image?.getAttribute('src') || '').toLowerCase();
          return src.includes(color) && src.includes(desiredFrame) && (src.includes('floor') || src.includes('frame'));
        }) || slides.find(e => e.dataset.mediaId?.endsWith(`-${variant.featured_media?.id}`));
        if (target) {
          gallery.prepend(target);
          gallery.scrollLeft = 0;
          section.querySelectorAll('.product__media-thumbnail-item').forEach(item => {
            const active = item.dataset.target === target.dataset.mediaId;
            item.classList.toggle('is-active',active);
            item.querySelector('button')?.setAttribute('aria-current',String(active));
          });
        }
      }
      currentId = input.value;
      syncPrice();
    }
    input.addEventListener('change',update);
    picker.addEventListener('change',() => queueMicrotask(update));
    if (price) new MutationObserver(syncPrice).observe(price,{childList:true,subtree:true,characterData:true});
    mobile.addEventListener('change',positionQuantity);
    positionQuantity();
    update();
  }
  function start() { document.querySelectorAll('.em-mobile-redesign').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start);
  else start();
  document.addEventListener('shopify:section:load',start);
})();


